export const isValidJerseyNumber = (
  jersey: string | number | null | undefined,
): boolean => {
  if (jersey === null || jersey === undefined) return false;

  if (typeof jersey === 'string') {
    return jersey.trim() !== '';
  }

  return true;
};
